export default {
      id: "playNextDoubleStep-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#playNextDoubleStep-usage",
      toString: function () {
        return this.url;
      }
    }